

import {Color4} from "@babylonjs/core/Maths/math.color";
import {DynamicTexture} from "@babylonjs/core/Materials/Textures/dynamicTexture";
import {StandardMaterial} from "@babylonjs/core/Materials/standardMaterial";
import { VertexBuffer } from "@babylonjs/core/Meshes/buffer";

import {BoxBuilder} from "@babylonjs/core/Meshes/Builders/boxBuilder";

export class Cuboid {
    constructor (position, color, world) {
        this.position = position;
        this.color = color;
        this.world = world;
        this.delta = world.delta; 4.0 //0.4
        this.scaling = world.scaling;
        this.nameBase = "box"
        }

    create (labeled)  {
        var name = this.nameBase + this.position.id;

        this.box = this.createBox(name);

        this.setLabeled(labeled);
        }

    setLabeled = (labeled) => {
        if (labeled) {
            this.box.material = this.getMaterial()
            } else {
            this.box.material = null;
            }
        }

    filter = (containerId, level) => {
        var display = true;
        if (containerId != null) {
            if (this.position.c + 1 != containerId) {
                display = false;
                }
            }

        if (level != null) {
            if (this.position.y > level) {
                display = false;
                }
            }
        this.box.setEnabled(display);
        }

    getBox = () => {
        var ret;

        if (this.world.boxCache.length == 0) {
            var color = new Color4(0.0, 0.0, 0.0, 1.0);
            var colors = [color, color, color, color, color, color];

            ret = BoxBuilder.CreateBox(name,
                                {
                                        faceColors: colors,
                                        updateable: true,
                                        wrap: true
                                        },
                                        this.scene);

            } else {
            ret = this.world.boxCache.pop();
            }
        return ret;
        }

    freeBox = () => {
        this.box.setEnabled(false);
        this.world.boxCache.push(this.box);
        this.box = null;
        }

    createBox = (name) => {
        var thisBox = this.getBox();

        thisBox.scaling.x = this.scaling * (this.position.depth - this.delta);
        thisBox.scaling.y = this.scaling * (this.position.height - this.delta);
        thisBox.scaling.z = this.scaling * (this.position.width - this.delta);
        var boxColors = thisBox.getVerticesData(VertexBuffer.ColorKind);
        var boxIndices = thisBox.getIndices();

        for (var i in boxIndices) {
            boxColors[4 * i] = this.color.r;
            boxColors[4 * i + 1] = this.color.g;
            boxColors[4 * i + 2] = this.color.b;
            boxColors[4 * i + 3] = this.color.a;
            }

        thisBox.setVerticesData(VertexBuffer.ColorKind, boxColors);

        thisBox.position.x = this.scaling * ((this.position.c - this.position.c % this.world.cFactor) / this.world.cFactor * this.world.xFactor + this.position.x + this.position.depth / 2 + 0.1);
        thisBox.position.y = this.scaling * (this.position.y + this.position.height / 2 + 0.1);
        thisBox.position.z = this.scaling * (((this.position.c % this.world.cFactor))* this.world.zFactor + this.position.z + this.position.width / 2 + 0.1);

        thisBox.material = null;
        thisBox.setEnabled(true);

        this.box = thisBox;

        return thisBox;
        }

    getMaterial = () => {
        var id = this.position.id;
        var text = this.position.text || ("" + (id+1) + ":" + this.position.depth + "x" + this.position.width + "x" + this.position.height);
        var lines = text.split("\n");

        var mat = this.world.materialCache[text];
        if (mat != undefined) {
            return mat;
            }

        var factor = Math.min(20, 2000 * this.scaling / (Math.max(Math.max(this.position.width, this.position.height), this.position.depth)));

        var textureParms =  {
                            width:  this.scaling * (this.position.width * factor),
                            height: this.scaling * (this.position.height * factor)
                            };
        //console.log(textureParms)

        var dynamicTexture = new DynamicTexture("dynamicTexture" + id,
                                                textureParms,
                                                this.world.scene,
                                                true);

        var ctx = dynamicTexture.getContext();

        ctx.font = "12px Arial";

        var lineCount = lines.length;
        var maxTextWidth = 1;
        for (var line in lines) {
            var textWidth = ctx.measureText(lines[line]).width;
            maxTextWidth = Math.max(maxTextWidth, textWidth);
            }
        //console.log(lineCount);
        //console.log(maxTextWidth);
        var ratio = maxTextWidth / 12;
        var fontSize = Math.floor(this.scaling * this.position.width * factor / (ratio * 1.1));

        fontSize = Math.min(this.scaling * this.position.height * factor * 0.9 / lineCount, fontSize / lineCount);

        var font = "" + fontSize + "px Arial";

        //console.log(font);
        var y = 1 *Math.ceil(textureParms.height / (lineCount + 1));

        var clearColor = "#ffffff";

        for (line in lines) {
            var thisLine = lines[line];
            //console.log(y);
            //console.log(thisLine);
            dynamicTexture.drawText(thisLine, null, y, font, "#000000", clearColor, true, true);

            clearColor = null;

            y += textureParms.height / (lineCount + 1);
            //break;
            }
        //dynamicTexture.update();
        mat = new StandardMaterial("mat" + id, this.world.scene);
        mat.diffuseTexture = dynamicTexture;

        this.world.materialCache[text] = mat;

        return mat;
        }
    }

export class ContainerCuboid extends Cuboid {
    constructor (position, color, world) {
        position.x = 0;
        position.y = 0;
        position.z = 0;
        super(position, color, world);
        this.delta = world.delta / 2;
        this.nameBase = "container";
        }

    create () {
        super.create();

        if (!this.world.containerMaterial) {
            var containerMat = new StandardMaterial("matContainer", this.world.scene);
            containerMat.alpha = 0.3;
            this.world.containerMaterial = containerMat;
            }
        this.box.material = this.world.containerMaterial;
        }

    setLabeled = (labeled) => {
        // Containers dont have labels
        }
    }

export class FloorCuboid extends ContainerCuboid {
    constructor (position, color, world) {
        super(position, color, world);
        position.x = -position.depth * 0.1;
        position.y = -1;
        position.z = -position.width * 0.1;
        this.delta = world.delta / 2;
        this.nameBase = "floor";
        }

    }